import { CROSS_ORIGIN_XSRF_CONFIG, CrossOriginXsrfConfig } from './xsrf.config';
import { Provider } from '@angular/core';

const DEFAULT_CONFIG: CrossOriginXsrfConfig = {
  trustedApiOrigins: [],
  cookieName: 'XSRF-TOKEN',
  headerName: 'X-XSRF-TOKEN',
};

export function provideCrossOriginXsrfConfig(config: Partial<CrossOriginXsrfConfig>): Provider {
  return {
    provide: CROSS_ORIGIN_XSRF_CONFIG,
    useValue: {
      ...DEFAULT_CONFIG,
      ...config,
    },
  };
}
